<template lang="pug">
#HistoryDetail
  .container-list
    b-card(border-variant="light")
      .d-inline-flex.align-items-center
        b-icon.mr-3(icon="info-circle-fill", variant="primary" font-scale="1.5")
        strong Descripción:
        div.mx-2 {{part.description}}
        strong.ml-2 Ubicación:
        div.ml-2.mr-4 {{part.real_location}}
        strong.ml-4 Buenos
        div.ml-4 {{part.cantidad_buenos}}
        strong.ml-4 Allocated
        div.ml-4 {{part.cantidad_allocated}}
        strong.ml-4 Drop
        div.ml-4 {{part.cantidad_drop}}
        strong.ml-4 Malos
        div.ml-4 {{part.cantidad_malos}}
        strong.ml-4 Salida
        div.ml-4 {{part.cantidad_salida}}
    b-table(
      :items="historyItems",
      :fields="fields",
      head-row-variant="light-primary",
      thead-class="text-black tabla-thead",
      tbody-class="tabla-tbody",
      tbody-tr-class="bg-white",
      responsive,
      :busy="loading",
      show-empty,
      empty-text="Sin datos en historial"
    )
      template(#cell(created_at)='value')
        div {{value.item.created_at | moment('DD-MM-YYYY HH:mm')}} Hrs.
      template(#cell(rma)='value')
        div(style="font-weight: bold; color:#253590") {{value.item.rma}}
      template(#cell(ot)='value')
        div(style="font-weight: bold; color:#253590") {{value.item.ot}}
  .d-flex.flex-row-reverse
    b-pagination(
      v-model="currentPage",
      :total-rows="count",
      prev-text="Ant.",
      next-text="Sig.",
      @change="handlePageChange"
    )
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'HistoryDetail',
  data() {
    return {
      historyItems: [],
      currentPage: 1,
      count: 0,
      part: {},
      loading: false,
      fields: [
        { key: 'created_at', label: 'Fecha del Movimiento', sortable: true },
        { key: 'tipo', label: 'Tipo de Movimiento', sortable: true },
        { key: 'cantidad', label: 'Cantidad', sortable: true },
        { key: 'rma', label: 'R.M.A Asociado' },
        { key: 'ot', label: 'O.T Asociada' },
        { key: 'user', label: 'Usuario' },
      ],
    }
  },
  methods: {
    ...mapActions('Warehouse', ['getHistoryPart']),
    async fetchData(page = 1) {
      this.loading = true
      const resp = await this.getHistoryPart({
        pk: this.$route.params.id,
        page,
      })
      if (resp.status === 200) {
        this.historyItems = resp.data.results
        this.count = resp.data.count
        this.part = resp.data.parte
      }
      this.loading = false
    },
    handlePageChange(page) {
      this.fetchData(page)
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
<style lang="scss">
@import '@/style/colors.scss';

// Iconos de ordenamiento en gris ($samtek-grey)
$sort-svg: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>";
$sort-up: "<path fill='%23525252' d='M50 8l38 44H12z'/>";
$sort-up-soft: "<path fill='%23525252' opacity='.5' d='M50 8l38 44H12z'/>";
$sort-down: "<path fill='%23525252' d='M50 92L12 48h76z'/>";
$sort-down-soft: "<path fill='%23525252' opacity='.5' d='M50 92L12 48h76z'/>";
$sort-end: "</svg>";

$sort-icon: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down-soft}#{$sort-end}");
$sort-icon-asc: url("#{$sort-svg}#{$sort-up}#{$sort-down-soft}#{$sort-end}");
$sort-icon-desc: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down}#{$sort-end}");

// Estilos del componente, anidados para no filtrar al resto de la app
#HistoryDetail {
  // Tabla
  .b-table {
    margin-bottom: 0;

    thead th {
      height: 50px;
      padding: 0 40px;
      font-size: 16px;
      font-weight: 700;
      color: $samtek-grey !important;
      background-color: $table-head-bg;
      border: none;
      vertical-align: middle;
    }

    thead th[aria-sort] {
      background-size: 16px 16px;
      background-position: right 16px center;
    }

    thead th[aria-sort='none'] {
      background-image: $sort-icon;
    }

    thead th[aria-sort='ascending'] {
      background-image: $sort-icon-asc;
    }

    thead th[aria-sort='descending'] {
      background-image: $sort-icon-desc;
    }

    tbody tr {
      height: 50px;
      background-color: #fff;
    }

    tbody td {
      height: 50px;
      padding: 0 40px;
      font-size: 15px;
      color: $samtek-black;
      background-color: #fff;
      border: none;
      vertical-align: middle;
    }

    tbody td:first-child {
      font-weight: 700;
    }

    // Columna numérica: Cantidad
    tbody td:nth-child(3) {
      font-weight: 500;
      color: $blue-accent !important;
      text-align: right;
    }
  }

  // Paginación
  .page-link {
    color: $samtek-grey;
    background-color: #fff;
    border: 1px solid $table-head-bg;

    &:hover {
      color: $samtek-grey;
      background-color: $center-bg;
      border-color: $table-head-bg;
      box-shadow: none;
    }
  }

  .page-item.active .page-link {
    color: $samtek-black;
    background-color: $samtek-yellow;
    border-color: $samtek-grey;
  }

  .page-item.disabled .page-link {
    color: $samtek-grey;
    background-color: #fff;
    border: 1px solid $table-head-bg;
  }
}

</style>
